/**
 * A timezone parser for value and display text
 */

export function convertTimeZoneDisplayText(time_zone) {
  switch (time_zone) {
    case "America/Los_Angeles":
      return "(PT)";
    case "America/Boise":
      return "(MT)";
    case "America/Chicago":
      return "(CT)";
    case "America/New_York":
      return "(ET)";
    case "America/Anchorage":
      return "(AT)";
    case "America/Adak":
      return "(HDT)";
    case "Pacific/Honolulu":
      return "(HST)";
    default:
      return "(PT)";
  }
}

export function convertTimeZoneValue(timeZoneText) {
  if (timeZoneText.includes("Pacific Time")) {
    return "America/Los_Angeles";
  } else if (timeZoneText.includes("Mountain Time")) {
    return "America/Boise";
  } else if (timeZoneText.includes("Central Time")) {
    return "America/Chicago";
  } else if (timeZoneText.includes("Eastern Time")) {
    return "America/New_York";
  } else if (timeZoneText.includes("Alaska Time")) {
    return "America/Anchorage";
  } else if (timeZoneText.includes("Hawaii-Aleutian Time")) {
    return "America/Adak";
  } else if (timeZoneText.includes("Hawaii-Honolulu Time")) {
    return "Pacific/Honolulu";
  }
  return "America/Los_Angeles";
}

export function formatTimeFromDb(timeString, timeZone) {
  var split = timeString.split(":");
  var hour = parseInt(split[0].replace(/[^0-9]+/g, ""));
  var minutes = split[1].replace(/[^0-9]+/g, "");
  var timeZoneText = convertTimeZoneDisplayText(timeZone);
  var timeZoneString = timeZoneText.substring(
    timeZoneText.indexOf("("),
    timeZoneText.indexOf(")") + 1
  );

  var am = "a.m.";
  if (hour > 11) {
    am = "p.m.";
  }
  if (hour > 12) {
    hour -= 12;
  }

  if (hour === 0) {
    hour = 12;
  }

  if (minutes.length < 2) {
    minutes = "0" + minutes;
  }
  return `${hour}:${minutes} ${am} ${timeZoneString}`;
}
